import { Routes } from "@angular/router";
import { AppComponent } from "./app.component";
const ɵ0 = () => import("./world-records/world-records.module.ngfactory").then(m => m.WorldRecordsModuleNgFactory), ɵ1 = () => import("./world-records/world-records.module.ngfactory").then(m => m.WorldRecordsModuleNgFactory);
const routes = [
    { path: "", component: AppComponent, pathMatch: "full" },
    {
        path: "",
        children: [
            {
                path: "world-records",
                loadChildren: ɵ0
            },
            {
                path: "records-du-monde",
                loadChildren: ɵ1
            },
        ]
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1 };
